import React, { useContext } from 'react';
import cls from 'classnames';

import Circle from '../../Icon/Circle';
import { MyContext } from '../../../../config/context-manager';

import styles from './style.module.scss';

type ThemeType = 'allWhite' | 'default' | 'allRed' | 'allBlue' | 'allGreen' | 'allYellow';
interface TitleProps {
  className?: string;
  theme?: ThemeType;
}

const Title: React.FC<TitleProps> = ({ className, children, theme = 'default' }) => {
  const { locale } = useContext(MyContext);
  const classes = cls(styles.container, className, styles[`${theme}`], {
    [styles.localeEn]: locale === 'en',
  });

  return (
    <div className={classes}>
      <div className={styles.content}>
        {typeof children === 'string' ? <h3 dangerouslySetInnerHTML={{ __html: children }} /> : <h3>{children}</h3>}
        <span className={styles.round}>
          <Circle className={styles.circleLeft} />
          <Circle className={styles.circleRight} />
        </span>
      </div>
    </div>
  );
};

export default Title;
